import React, { useState, Fragment, useEffect } from 'react';
import {
    Row, Button, Card,
    CardBody, CustomInput,
    FormGroup,
    Label,
    InputGroupAddon,
    InputGroupText,
    Input,
    InputGroup
} from "reactstrap";
import { Colxx } from "../../../../../components/common/CustomBootstrap";

export default function AiEmailAssistant({
    templateData,
    updateTemplateData,
    assistantList,
    clickBusiness,
    submit,
    isSuccess, stepStatusMap, stepCreate, userName, id, emailAutomationOption,
    setEmailAutomationOption
}) {
    const [showEmailConfig, setShowEmailConfig] = useState(false);
    const [emailAssistantCreated, setEmailAssistantCreated] = useState(false);
    const [hasChanged, setHasChanged] = useState(false);
    const isUpdatedEmailAssistant = stepStatusMap?.emailAssistant === "UpdatedOrCreated";

    useEffect(() => {
        if (isUpdatedEmailAssistant) {
            setEmailAssistantCreated(true);
            setShowEmailConfig(true);
        }
    }, [isUpdatedEmailAssistant]);

    const handleSubmit = async () => {
        await submit()
    };
    const handleNotNow = async () => {
        await stepCreate({
            onboardSessionId: id,
            stepName: "email-automation",
            status: "Skipped",
            creator: userName,
            modifiedBy: "Dashboard",
        });
        clickBusiness()
    };

    return (
        <>
            {!showEmailConfig && !emailAssistantCreated && (

                <Colxx sm={12} className="mb-4 ml-2">

                    <h5>Select Email Assistant Creation Option</h5>

                    <FormGroup className="mt-4">
                        <CustomInput
                            type="radio"
                            id="emailCreateNew"
                            value={1}
                            label="Create New"
                            checked={emailAutomationOption === 1}
                            onChange={() => setEmailAutomationOption(1)}
                        />
                    </FormGroup>

                    <FormGroup>
                        <CustomInput
                            type="radio"
                            id="emailUseExisting"
                            value={2}
                            label="Use Existing"
                            checked={emailAutomationOption === 2}
                            onChange={() => setEmailAutomationOption(2)}
                        />
                    </FormGroup>

                    {emailAutomationOption && (
                        <Button
                            color="primary"
                            size="lg"
                            outline
                            className="mt-3"
                            onClick={() => setShowEmailConfig(true)}
                        >
                            Process...
                        </Button>
                    )}

                </Colxx>
            )}
            {showEmailConfig && !emailAssistantCreated && (
                <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "10px" }}>
                    <Button
                        color="secondary"
                        outline
                        size="sm"
                        onClick={() => setShowEmailConfig(false)}
                    >
                        Back
                    </Button>
                </div>
            )}
            {showEmailConfig && (
                <div className="mb-4 ml-4 mt-4">
                    <Row>

                        {/* ---------- AI EMAIL ASSISTANT ENABLED ---------- */}
                        <Colxx sm={12} className="mb-2">
                            <h5>AI Email Assistant</h5>

                            <FormGroup>
                                <CustomInput
                                    type="checkbox"
                                    id="isEmail"
                                    checked={true}
                                    disabled={true}
                                    label="AI Email Assistant"
                                />
                            </FormGroup>
                        </Colxx>

                        {/* ---------- DYNAMIC FLOW ---------- */}
                        {assistantList && assistantList.length > 0 && (
                            <Colxx xxs="12" className="mb-4">
                                <Label style={{ fontSize: "14px" }}>Dynamic Conversation Flow</Label>

                                <Input
                                    className="w-80 input_sty"
                                    type="select"
                                    name="dynamicConversationFlow"
                                    value={templateData.dynamicFlowId || ""}
                                    onChange={(e) => {
                                        updateTemplateData(
                                            "dynamicFlowId",
                                            e.target.value || null
                                        )
                                        setHasChanged(true)
                                    }
                                    }
                                >
                                    <option value="">
                                        Select a Dynamic Conversation Flow
                                    </option>

                                    {assistantList.map((assist, index) => (
                                        <option key={index} value={assist.openAiAssistantId}>
                                            {assist.name} ({assist.openAiAssistantId})
                                        </option>
                                    ))}
                                </Input>
                            </Colxx>
                        )}

                        {/* ---------- SUBMIT ---------- */}
                        <Colxx xxs="12" className="mb-4 text-right" style={{ marginTop: '80px' }}>
                            {isUpdatedEmailAssistant && !hasChanged ? (
                                <Button
                                    color="primary"
                                    size="lg"
                                    outline
                                    className=" mr-1"
                                    onClick={clickBusiness}
                                >
                                    Next
                                </Button>
                            )
                                : (
                                    <div className='widget-wrap'>
                                        <Button
                                            color="primary"
                                            size="lg"
                                            outline
                                            onClick={handleSubmit}
                                        >
                                            Create AI Email Assistant
                                        </Button>
                                        <h6
                                            style={{ display: 'flex' }}
                                            className="ml-4 not-now"
                                            onClick={handleNotNow}
                                        >
                                            Not Now <svg className='not-now' width="60" height="20" viewBox="70 15 40 20" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M60 25 H100 L90 15 M100 25 L90 35"
                                                    fill="none"
                                                    stroke="grey"
                                                    stroke-width="2"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                            </svg>

                                        </h6>
                                    </div>
                                )
                            }
                        </Colxx>

                    </Row>
                </div>
            )}
        </>
    );
}